<template>
  <div>
    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <SectionTemplate
        v-if="!loading && item.title"
        class="overflow-hidden position-relative item"
      >
        <v-row class="position-relative" justify="center">
          <v-col cols="12" sm="10" lg="6">
            <div class="text-center text-lg-left">
              <TitleWidget>{{ item.title }}</TitleWidget>
            </div>

            <img
              v-if="
                item.img &&
                item.img.featured &&
                item.img.featured.path &&
                !lgAndUp
              "
              :src="files + item.img.featured.path + '?resize=1&w=960'"
              :alt="item.title"
              class="d-block mt-4 mx-auto"
              width="80%"
            />

            <div
              v-if="item.introduction"
              class="
                grey--text
                text--darken-1 text-body-1 text-center text-md-left
                mt-4
                item-text
              "
              v-html="item.introduction"
            ></div>

            <div class="text-center text-md-left mt-8 mt-md-12">
              <ButtonWidget :to="path">Saiba Mais</ButtonWidget>
            </div>
          </v-col>

          <v-col
            v-if="
              item.img && item.img.featured && item.img.featured.path && lgAndUp
            "
            cols="6"
          >
            <img
              v-if="item.img && item.img.featured && item.img.featured.path"
              :src="files + item.img.featured.path + '?resize=1&w=960'"
              :alt="item.title"
              class="d-block"
              width="100%"
            />
          </v-col>
        </v-row>
      </SectionTemplate>
    </transition>
  </div>
</template>

<script>
import SectionTemplate from "../templates/SectionTemplate.vue";
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "about",
  path: "/quem-somos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    lgAndUp() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
  },
  components: {
    SectionTemplate,
    LoadingWidget,
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &:before {
    background-color: var(--v-primary-base);
    bottom: 50%;
    content: "";
    height: 100vw;
    left: 30vw;
    position: absolute;
    transform: rotate(45deg);
    width: 100vw;

    @media screen and (max-width: 1264px) {
      bottom: initial;
      height: 400px;
      left: initial;
      right: -200px;
      top: -200px;
      width: 400px;

      @media screen and (max-width: 960px) {
        height: 260px;
        right: -130px;
        top: -130px;
        width: 260px;
      }

      @media screen and (max-width: 600px) {
        height: 200px;
        right: -100px;
        top: -100px;
        width: 200px;
      }
    }
  }

  &:after {
    background-color: var(--v-primary-base);
    bottom: -200px;
    content: "";
    height: 400px;
    left: -200px;
    position: absolute;
    transform: rotate(45deg);
    width: 400px;

    @media screen and (max-width: 960px) {
      bottom: -130px;
      height: 260px;
      left: -130px;
      width: 260px;
    }

    @media screen and (max-width: 600px) {
      bottom: -100px;
      height: 200px;
      left: -100px;
      width: 200px;
    }
  }

  &-text::v-deep {
    line-height: 2em !important;

    p:last-child {
      margin-bottom: 0;
    }
  }
}

.item::v-deep {
  .container {
    z-index: 2;
  }
}
</style>
